import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GaTrackingEventAction, 
  GaTrackingEventCategory, 
  GaTrackingEventName, 
  GATrackingEventType
} from '../../constants';
export class GATrackingAddToCartMoreThanInStockInteractionEvent implements GATrackingEvent {

  constructor(private label: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.QuantityPickerInteraction;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.AddToCartMoreThanInStock,
      label: this.label,
      gtmCustom: {
        action: GaTrackingEventAction.AddToCartMoreThanInStock,
        category: GaTrackingEventCategory.Interaction
      }
    };
  }
}
